import { useMemo } from 'react';
import { useCurrentProvider } from '../../../../Components/Permissions';
import { BeaconDashboard, BeaconDashboardTabs } from '../../types';
import { Permission, SaiDashboardType } from '../../../../graphQL';

type UseGetDashboardsResult =
  | { status: 'loading' }
  | { status: 'error'; error: string }
  | { status: 'success'; dashboards: BeaconDashboardTabs[] };

const allDashboards: BeaconDashboard[] = [
  {
    key: SaiDashboardType.SaiMonitoring,
    displayName: 'Overview',
    requiredPermission: Permission.SaiDataViewMonitoringOwnorg,
  },
  {
    key: SaiDashboardType.SaiPopulation,
    displayName: 'Population',
    requiredPermission: Permission.SaiDataViewPopulationOwnorg,
  },
  {
    key: SaiDashboardType.SaiFlaggedStudents,
    displayName: 'Concerns',
    requiredPermission: Permission.SaiDataViewFlaggedstudentsOwnorg,
  },
];

/**
 * This is currently a mocked hook. The implementation will be added in a future PR
 * with the proper GraphQL query to fetch the dashboards available to the user.
 */
export const useGetDashboards = (): UseGetDashboardsResult => {
  const { hasPermission } = useCurrentProvider();

  const availableDashboards: BeaconDashboardTabs[] = useMemo(
    () =>
      allDashboards
        .filter(dashboard => hasPermission(dashboard.requiredPermission))
        .map(({ key, displayName }) => ({ key, displayName })),
    [hasPermission]
  );

  return { status: 'success', dashboards: availableDashboards };
};
